import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePurchasesQuoteSupplierModel,
  DeletePurchasesQuoteSupplierModel,
  SearchPurchasesQuoteSupplierModel,
} from '../../../models/purchase-quote-supplier.model'

@Injectable({
  providedIn: 'root',
})
export class PurchasesQuoteSupplierService {
  private baseUrl = environment.baseUrl
  private resource = 'FornecedorCotacao'

  constructor(private httpClient: HttpClient) {}

  public createPurchasesQuoteSupplier(
    model: CreatePurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editPurchasesQuoteSupplier(
    model: any,
    // model: EditPurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public editFinalPurchasesQuoteSupplier(
    model: any,
    // model: EditPurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit/finalizada`,
      model,
    )
  }

  public deletePurchasesQuoteSupplier(
    model: DeletePurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public getPurchasesQuoteSupplierById(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public listPagedPurchasesQuoteSupplier(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPurchasesQuoteSupplierByStatus(
    page: number,
    rows = 15,
    idStatus: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/${idStatus}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchListPagedPurchasesQuoteSupplier(
    page: number,
    rows = 15,
    model: SearchPurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPurchasesQuoteSupplier(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public searchListPurchasesQuoteSupplier(
    model: SearchPurchasesQuoteSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listPagedPurchasesQuoteSupplierByTG(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Compras/Solicitacao/Tg/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPurchasesQuoteSupplierByTGId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Compras/Solicitacao/Tg/abertas/${id}`,
    )
  }

  public listPagedDiscountRequests(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Compras/desconto/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public applyDiscount(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Compras/desconto/aplicar`,
      model,
    )
  }

  public listPagedPurchasesQuoteSupplierByRequestId(
    requestId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Compras/Cotacoes/Tg/Solicitacao/${requestId}`,
    )
  }

  public searchPagedPurchasesQuoteSupplierByTG(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Compras/Solicitacao/Tg/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public finishPurchasesQuoteSupplierByRequestId(
    requestId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Compras/Solicitacao/fechar/${requestId}`,
      {},
    )
  }
}
